import { render, staticRenderFns } from "./zdysList.vue?vue&type=template&id=8a98e67a&scoped=true"
import script from "./zdysList.vue?vue&type=script&lang=js"
export * from "./zdysList.vue?vue&type=script&lang=js"
import style0 from "./zdysList.vue?vue&type=style&index=0&id=8a98e67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a98e67a",
  null
  
)

export default component.exports